import {connect} from 'react-redux';
import EntryCaptainChangeFormModal from './EntryCaptainChangeFormModal.jsx';
import {
  validateEntryCaptainChangeForm,
  handleEntryCaptainChangeFormSave,
  handleEntryChangeCaptainCancelClick,
  handleEntryChangeCaptainSearchClick
} from './actions';
import {
  setAllAffectedVirtualEntriesSelected
} from '../captainDetail/actionTypes';

const mapStateToProps = state => {
  return ({
    visible: state.admin.entryDetail.showEntryDetailChangeCaptainModal,
    isNew: state.admin.entryDetail.isNew,
    submitButtonText: state.admin.entryDetail.isNew ? 'Create' : 'Update',
    ...state.admin.entryDetail.coordinator,
    validate: validateEntryCaptainChangeForm,
    affectedVirtualEntries: state.admin.captainDetail.affectedVirtualEntries,
    allAffectedVirtualEntriesSelected: state.admin.captainDetail.allAffectedVirtualEntriesSelected
});
};

const mapDispatchToProps = dispatch => ({
  onCancelClick: () => dispatch(handleEntryChangeCaptainCancelClick()),
  onSubmit: data => dispatch(handleEntryCaptainChangeFormSave(data)),
  onSearchClick: () => dispatch(handleEntryChangeCaptainSearchClick()),
  onSelectAllChecked: () => dispatch(setAllAffectedVirtualEntriesSelected())
});

export default connect(mapStateToProps, mapDispatchToProps)(EntryCaptainChangeFormModal);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryCaptainChangeFormModalContainer.jsx